import React from 'react';
import PropTypes from 'prop-types';
import { withAreaGetter } from 'providers/AreasConsumers';
import BrowserComponent from './BrowserComponent';
import HeaderPortal from 'components/layout/HeaderPortal';
import { areas } from 'constants/areas';
import Portal from 'utils/portal/Portal';
import IconButton from 'components/common/buttons/IconButton';
import HierarchyModalComponent from './HierarchyModalComponent';
import { hierarchyInEditRootIdVar } from '../variables';
import PermissionCheck from 'components/common/PermissionCheck';
import { ADMIN_CITIES_READ, ADMIN_CITIES_WRITE } from 'constants/rightsCodes';
import { usePermission } from 'providers/RightsHooks';

const Route = ({ getElemByAreaKey }) => {
  const canWrite = usePermission(ADMIN_CITIES_WRITE);

  return (
    <>
      <HeaderPortal />
      {canWrite && (
        <Portal container={getElemByAreaKey(areas.headerLinks)}>
          <IconButton onClick={() => hierarchyInEditRootIdVar(crypto.randomUUID())} type='add' size='medium' iconFontSize='medium' />
        </Portal>
      )}
      <PermissionCheck authorizationCode={ADMIN_CITIES_READ}>
        <BrowserComponent />
        <HierarchyModalComponent />
      </PermissionCheck>
    </>
  );
};

Route.propTypes = {
  getElemByAreaKey: PropTypes.func.isRequired
};

export default withAreaGetter(Route);
